import SectionTitle from "@/components/base/SectionTitle";

const testimonials = [
  {
    name: "阿远",
    role: "动画收藏爱好者",
    avatar: "ri-user-3-line",
    quote:
      "以前散着收藏总是漏，自从按归档列表查，按系列批量补齐特别省事，整理贴补全得也很及时。",
  },
  {
    name: "小南",
    role: "漫画读者",
    avatar: "ri-user-smile-line",
    quote:
      "按作者整理的卷宗太实用了，目录清清楚楚，追新书之前先来翻一眼有没有遗漏，心里有底。",
  },
  {
    name: "阿茶",
    role: "游戏玩家",
    avatar: "ri-user-2-line",
    quote:
      "版本对照做得很细，主机和 PC 分得明明白白，收藏系列的时候不怕买重也不怕漏。",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-50">
      <div className="container-site py-14 md:py-20">
        <SectionTitle
          eyebrow="用户口碑"
          title="收藏者们怎么说"
          desc="来自不同板块收藏爱好者的真实反馈，他们通过合集与归档找到了更省心的整理方式。"
        />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-100/70 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-6 text-foreground-700">
                {t.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i className={`${t.avatar} text-lg`}></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}